import AntMenu, { type MenuProps as AntMenuProps } from "antd/lib/menu";
import clsx from "clsx";

import { Chevron } from "@sol/icons";

import styles from "./Menu.module.css";

export type MenuProps = AntMenuProps;

const defaultExpandIcon = () => <Chevron className="ant-menu-submenu-expand-icon-custom" direction="down" size={12} />;

export const Menu = ({ className, expandIcon, ...props }: MenuProps) => {
    return <AntMenu className={clsx(styles.menu, className)} expandIcon={expandIcon ?? defaultExpandIcon} {...props} />;
};
